import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { ungroup } from "@/input/utils/groupUngroup";

import type { GroupNodeModel } from "@/models/nodes/GroupNodeModel";

type Props = {
  node: GroupNodeModel;
};

export const UngroupButton = observer(function UngroupButton({ node }: Props) {
  const { doc } = node;
  const t = useTranslations("sidebar");

  const handleClick = () => {
    doc.transact(() => {
      ungroup(doc);
    }, "matrix:ungroup");
  };

  return (
    <Sidebar.Button
      icon={<Icon name="math/Ungroup" />}
      title={t("activeNode.group.actions.ungroup")}
      onClick={handleClick}
      className="h-8.5 min-h-8.5"
      inverted
    />
  );
});
